import { call, put, takeEvery } from 'redux-saga/effects';

import * as actions from './_actions';
import * as types from './_actionTypes';

function* fetchAdminStatsSaga() {
  try {
    // Mock data for demo
    const mockStats = {
      totalColleges: 45,
      totalStudents: 12567,
      totalSMEs: 89,
      totalCertificates: 8934,
      pendingApprovals: 23
    };
    
    yield put(actions.fetchAdminStatsSuccess(mockStats));
  } catch (error) {
    yield put(actions.fetchAdminStatsFailure(error.message));
  }
}

function* fetchRecentActivitiesSaga() {
  try {
    const mockActivities = [
      { id: 1, type: 'college_registration', message: 'New college registered: ABC University', time: '2 hours ago' },
      { id: 2, type: 'sme_approval', message: 'SME approved: Dr. John Smith', time: '4 hours ago' },
      { id: 3, type: 'certificate_issued', message: '150 certificates issued for Computer Science', time: '6 hours ago' },
      { id: 4, type: 'student_enrollment', message: '25 new student enrollments', time: '8 hours ago' },
    ];
    
    yield put(actions.fetchRecentActivitiesSuccess(mockActivities));
  } catch (error) {
    yield put(actions.fetchRecentActivitiesFailure(error.message));
  }
}

function* adminDashboardSaga() {
  yield takeEvery(types.FETCH_ADMIN_STATS_REQUEST, fetchAdminStatsSaga);
  yield takeEvery(types.FETCH_RECENT_ACTIVITIES_REQUEST, fetchRecentActivitiesSaga);
}

export default adminDashboardSaga;